import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonCommonModule } from '../../common/components/common.module';
import { GalleryComponent } from './gallery/gallery.component';
import { GridComponent } from './grid/grid.component';
import { GalleryYoutubeComponent } from './gallery-youtube/gallery-youtube.component';
import { VideoModule } from '../../video/components/video.module';

@NgModule({
  declarations: [GalleryComponent, GridComponent, GalleryYoutubeComponent],
  imports: [CommonModule, SkeletonCommonModule, VideoModule],
  exports: [GalleryComponent]
})
export class GalleryModule {}
